/* fl-fast-cart.js — v3
   1) O drawer abre NO CLIQUE, com o item em esqueleto (titulo, preco, cor/tamanho); o conteudo real
      entra quando a resposta chega. v3: com o carrinho vazio, o "carrinho vazio" do tema fica escondido
      enquanto carrega (classe fl-carregando) — antes aparecia junto com o esqueleto.
   2) O /cart/add.js ja devolve as secoes do drawer, entao a 2a chamada /cart.js sai do caminho critico.
   3) Enquanto o JS do tema nao assume o formulario, o botao fica travado — antes disso o clique
      mandava a cliente para uma pagina de erro do Shopify com o carrinho vazio. */
(function () {
  if (window.__flFastCart) return;
  window.__flFastCart = true;

  /* ---------- 1. trava o botao ate o tema assumir ---------- */
  function travarAteHidratar() {
    if (customElements.get('product-form')) return;
    var botoes = document.querySelectorAll('form[is="product-form"] [type="submit"]');
    botoes.forEach(function (b) { b.setAttribute('disabled', 'disabled'); b.setAttribute('aria-busy', 'true'); b.dataset.flTravado = '1'; });
    customElements.whenDefined('product-form').then(function () {
      document.querySelectorAll('[data-fl-travado]').forEach(function (b) {
        b.removeAttribute('disabled'); b.removeAttribute('aria-busy'); delete b.dataset.flTravado;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', travarAteHidratar);
  else travarAteHidratar();

  /* ---------- 2. esqueleto dentro do drawer ---------- */
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  /* cor/tamanho marcados no variant-picker ligado a este form */
  function variantesEscolhidas(form) {
    var fid = form.getAttribute('id');
    var picker = fid && document.querySelector('variant-picker[form="' + fid + '"]');
    if (!picker) return '';
    var vals = [];
    picker.querySelectorAll('input:checked, select').forEach(function (i) { if (i.value) vals.push(i.value); });
    return vals.join(' / ');
  }
  /* preco exibido na pagina, sem o texto oculto de acessibilidade ("Offer", "Angebot") */
  function precoExibido(form) {
    var sec = form.closest('.shopify-section') || document;
    var el = sec.querySelector('price-list sale-price');
    if (!el) return '';
    var c = el.cloneNode(true);
    c.querySelectorAll('.sr-only, .visually-hidden').forEach(function (x) { x.remove(); });
    return c.textContent.trim().replace(/\s+/g, ' ');
  }
  function abrirComEsqueleto(form) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.show !== 'function') return null;
    /* esqueleto so para o form principal da PDP — titulo, foto e preco vem da pagina; num "+ Add" da gaveta
       ou de uma compra rapida eles seriam do produto errado */
    if (form.closest('cart-drawer, quick-buy-drawer, quick-buy-modal, .horizontal-product, product-card')) return null;

    var img = document.querySelector('.product-gallery img, product-gallery img, [class*="product"] img');
    var titulo = (document.querySelector('h1') || {}).textContent || '';
    var variante = variantesEscolhidas(form);
    var preco = precoExibido(form);
    var ph = document.createElement('div');
    ph.className = 'fl-skeleton';
    ph.innerHTML =
      '<div class="fl-skeleton__row">' +
        (img ? '<img class="fl-skeleton__img" src="' + esc(img.currentSrc) + '" alt="">' : '<div class="fl-skeleton__img"></div>') +
        '<div class="fl-skeleton__txt"><span class="fl-skeleton__title">' + esc(titulo.trim().slice(0, 60)) + '</span>' +
        (preco ? '<span class="fl-skeleton__meta">' + esc(preco) + '</span>' : '<span class="fl-skeleton__bar"></span>') +
        (variante ? '<span class="fl-skeleton__meta fl-skeleton__meta--sub">' + esc(variante) + '</span>' : '<span class="fl-skeleton__bar fl-skeleton__bar--sm"></span>') +
        '</div>' +
      '</div>';

    var alvo = drawer.querySelector('.cart-drawer__line-items') || drawer.querySelector('.cart-drawer__content') || drawer;
    alvo.insertBefore(ph, alvo.firstChild);
    drawer.classList.add('fl-carregando'); /* esconde o "carrinho vazio" do tema enquanto carrega */
    drawer.show();
    return ph;
  }
  function limparEsqueleto() {
    document.querySelectorAll('.fl-skeleton').forEach(function (e) { e.remove(); });
    document.querySelectorAll('cart-drawer.fl-carregando').forEach(function (d) { d.classList.remove('fl-carregando'); });
  }

  /* ---------- 3. o add ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[is="product-form"]')) return;
    if (!window.Shopify || !Shopify.routes) return;
    if (form.checkValidity && !form.checkValidity()) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var drawerEl = document.querySelector('cart-drawer');
    var estavaVazio = !drawerEl || !drawerEl.querySelector('line-item');
    var esqueleto = abrirComEsqueleto(form);

    (async function () {
      var botoes = Array.prototype.filter.call(form.elements, function (b) { return b.type === 'submit'; });
      botoes.forEach(function (b) { b.setAttribute('disabled', 'disabled'); b.setAttribute('aria-busy', 'true'); });
      try {
        var sections = ['variant-added'];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));
        var fd = new FormData(form);
        fd.set('sections', sections.join(','));
        fd.set('sections_url', Shopify.routes.root + 'variants/' + form.id.value);

        var resp = await fetch(Shopify.routes.root + 'cart/add.js', { body: fd, method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        var json = await resp.json();
        botoes.forEach(function (b) { b.removeAttribute('disabled'); b.removeAttribute('aria-busy'); });

        if (!resp.ok) {
          limparEsqueleto();
          if (estavaVazio && drawerEl && typeof drawerEl.hide === 'function') drawerEl.hide();
          form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: json.description } }));
          return;
        }
        if (window.themeVariables && (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.pageType === 'cart')) {
          window.location.href = Shopify.routes.root + 'cart';
          return;
        }

        var cart = { sections: json['sections'] }, counted = null;
        try {
          var chaves = Object.keys(json['sections'] || {});
          for (var i = 0; i < chaves.length; i++) {
            var el = new DOMParser().parseFromString(json['sections'][chaves[i]] || '', 'text/html').querySelector('cart-count');
            if (el) { var n = parseInt(el.textContent.trim(), 10); if (!isNaN(n)) { counted = n; break; } }
          }
        } catch (err) {}
        cart.item_count = counted !== null ? counted : (json['quantity'] || 1);

        limparEsqueleto();
        form.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: json.items ? json.items : [json], cart: cart, blockCartDrawerOpening: false } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));

        fetch(Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); }).then(function (full) {
          full['sections'] = json['sections'];
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'cart:refresh', cart: full } }));
        }).catch(function () {});
      } catch (err) {
        botoes.forEach(function (b) { b.removeAttribute('disabled'); b.removeAttribute('aria-busy'); });
        limparEsqueleto();
        if (estavaVazio && drawerEl && typeof drawerEl.hide === 'function') drawerEl.hide();
        form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: String(err) } }));
      }
    })();
  }, true);
})();
